<template>
    <section class="contact_us section-padding">
        <div class="container">
            <div class="section-header text-center">
                <h2>Te ayudamos <span>con lo que necesites</span></h2>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <h3>Dejanos tus datos y te contactaremos</h3>
                    <div class="contact_form gray-bg">
                        <contactoForm />
                    </div>
                </div>
                <div class="col-md-6">
                    <h3>Datos de contacto</h3>
                    <div class="contact_detail">
                        <h5>Sede Calle 5</h5>
                        <ul>
                            <li>
                                <div class="icon_wrap">
                                    <i
                                        class="fa fa-map-marker"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                                <div class="contact_info_m">
                                    Calle 5 # 14 - 47 Esquina B/ San Juan Bosco
                                </div>
                            </li>
                            <li>
                                <div class="icon_wrap">
                                    <i
                                        class="fa fa-phone"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                                <div class="contact_info_m">
                                    <a href="tel:3188274142"> 318 827 4142</a>
                                </div>
                            </li>
                        </ul>
                        <h5>Sede Calle 8</h5>
                        <ul>
                            <li>
                                <div class="icon_wrap">
                                    <i
                                        class="fa fa-map-marker"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                                <div class="contact_info_m">
                                    Calle 18 Norte # 7 - 17  Esquina B/ Granada
                                </div>
                            </li>
                            <li>
                                <div class="icon_wrap">
                                    <i
                                        class="fa fa-phone"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                                <div class="contact_info_m">
                                    <a href="tel:3206660716"> 320 666 0716</a>
                                </div>
                            </li><!-- 
                            <li>
                                <div class="icon_wrap">
                                    <i
                                        class="fa fa-envelope-o"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                                <div class="contact_info_m">
                                    <a
                                        href="mailto:servicioalcliente@redautos.com"
                                        >servicioalcliente@redautos.com</a
                                    >
                                </div>
                            </li> -->
                        </ul>
                        <div class="map_wrap">
                            <iframe
                                src="https://www.google.com/maps/d/u/0/embed?mid=1hKgqPbx1_C7_ccH-bRJ3yqW_LyeuQlY3"
                                width="100%"
                                frameborder="0"
                                style="border:0"
                                allowfullscreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import contactoForm from "./contactoForm";
export default {
    components: {
        contactoForm
    }
};
</script>

<style lang="scss" scoped></style>
